import React from 'react';
import TextField from 'domains/core/components/TextField';
import { VoiceTemplateState } from '../VoiceTemplateReducer';
import { VoiceTemplateAction, VoiceTemplateActionType } from '../VoiceTemplateActions';

type PropType = {
    voiceTemplateState: VoiceTemplateState;
    voiceTemplateDispatchAction: React.Dispatch<VoiceTemplateAction>;
    isMessageLoading: boolean;
};

const TemplateNameInput: React.FunctionComponent<PropType> = ({
    voiceTemplateDispatchAction: dispatch,
    voiceTemplateState: state,
    isMessageLoading,
}: PropType) => {
    const handleChange = (newValue: string) => {
        dispatch({ type: VoiceTemplateActionType.SET_TEMPLATE_NAME, payload: newValue });
        return;
    };
    return (
        <TextField
            counterCurrent={state.templateName.length ?? 0}
            counterMax={255}
            data-testid="update-name-input"
            disabled={isMessageLoading}
            focused
            label="Name"
            value={state.templateName}
            width="50%"
            withClickAway
            withCounter
            onChange={(event) => handleChange(event.target.value)}
        />
    );
};

export default TemplateNameInput;
